import React from "react";

import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { KeysHelpHolder } from "./KeysHelpHolder";
import { LangDirectionContext } from "../../../context/LangDirectionContext";

const ButtonsHolder = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  top: 0;
`;

const ArrowButton = styled.div`
  min-width: 109px;
  width: auto;
  height: 41px;
  background-color: rgb(27, 170, 225);
  color: ${({ theme }) => theme.colors.white};
  padding: 0 20px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;

  span {
    padding: 0 5px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1px;
  }

  .arrow {
    border-style: solid;
    border-color: ${({ theme }) => theme.colors.white};
    border-width: 0 3px 3px 0;
    padding: 5px;
  }

  ${(props) =>
    props.next &&
    css`
      .arrow {
        transform: rotate(-45deg);
      }
    `};

  ${(props) =>
    props.backward &&
    css`
      .arrow {
        transform: rotate(135deg);
      }
    `};

  ${(props) =>
    props.direction === "rtl" &&
    props.backward &&
    css`
      .arrow {
        transform: rotate(-45deg);
      }
    `};

  ${(props) =>
    props.direction === "rtl" &&
    props.next &&
    css`
      .arrow {
        transform: rotate(135deg);
      }
    `};
`;

export function NextBackKey() {
  const { t } = useTranslation();
  const direction = React.useContext(LangDirectionContext);

  return (
    <KeysHelpHolder
      title={t("moveBackwardsAndForwards")}
      subtitle={t("usingTheBackOrNextButtons")}
    >
      <svg
        width="218"
        height="137"
        viewBox="0 0 218 137"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100.349 86.6864C100.349 86.6864 100.865 86.0414 101.639 85.7834C102.413 85.5254 103.058 85.5254 103.058 85.5254C103.058 85.5254 103.058 84.7515 103.316 83.8485C103.832 82.5586 104.735 80.6237 105.122 77.7858C105.38 75.7219 105.638 73.271 105.767 70.6911C105.896 67.5953 106.283 63.9834 105.638 60.7586C104.864 56.3728 103.445 53.0189 101.897 48.8911C100.736 45.7953 99.1884 41.9254 98.4144 38.9586C96.7375 33.0249 95.1896 27.6071 95.4475 24.1243C95.7055 21.6734 97.1245 20.2544 98.5434 19.8675C103.832 18.3195 105.638 24.6402 108.605 30.316C110.153 33.4118 112.604 36.5077 113.765 38.9586C115.184 41.7964 115.7 43.3444 115.7 43.3444C115.7 43.3444 118.795 39.8615 121.246 38.0556C122.536 37.1527 123.826 35.6047 124.729 35.2178C126.019 34.5728 129.502 34.5728 131.179 36.3787C134.275 39.8615 135.694 46.6982 135.694 46.6982C135.694 46.6982 138.532 46.4402 140.337 48.6331C142.272 50.955 142.788 52.245 144.594 56.8888C144.594 56.8888 147.432 55.2118 149.883 57.7917C151.947 59.8556 153.237 63.9834 154.785 68.3692C155.817 71.4651 157.752 72.884 157.752 77.6568C157.752 83.0746 158.268 89.3953 158.655 95.458C158.784 99.4568 158.526 103.327 159.171 106.68C159.945 110.421 159.042 108.357 163.04 115.968C163.685 117.129 163.943 120.096 162.395 122.418C155.817 131.834 130.534 144.347 121.891 131.447C119.827 128.351 118.666 124.869 116.732 122.805C113.378 119.451 108.605 119.451 104.606 115.71C97.3825 109.131 89.7718 104.101 87.7079 100.102C87.3209 99.3278 86.8049 96.3609 86.031 93.1361C85.515 90.9432 84.2251 89.0083 83.8381 87.0734C82.6771 81.9136 81.3872 80.4947 81.2582 78.0438C81.2582 76.1089 82.6771 72.884 82.2902 70.0462C82.1612 68.8852 81.3872 66.6923 81.1292 65.0154C80.7422 62.3065 81.5162 59.5976 83.8381 59.2107C85.644 58.9527 87.3209 59.4686 89.5138 61.4036C92.0937 63.8544 94.4156 67.4663 95.4475 70.1752C96.4795 72.755 95.7055 75.2059 95.7055 75.2059C95.7055 75.2059 96.4795 75.8509 96.9955 77.6568C97.2535 78.3018 97.5115 79.7207 97.7694 80.3657C98.4144 82.0426 98.9304 83.3325 99.1884 84.2355C99.4464 85.0095 99.1884 85.5254 99.1884 85.5254L100.349 86.6864Z"
          fill="white"
        />
        <path
          d="M112.217 24.3822C112.217 31.2189 106.67 36.7657 99.8331 36.7657C92.9965 36.7657 87.4497 31.2189 87.4497 24.3822C87.4497 17.5456 92.9965 11.9988 99.8331 11.9988C106.67 11.9988 112.217 17.5456 112.217 24.3822ZM99.8331 14.5787C94.4154 14.5787 89.9006 18.9645 89.9006 24.5112C89.9006 29.929 94.2864 34.4438 99.8331 34.4438C105.251 34.4438 109.766 30.058 109.766 24.5112C109.637 18.9645 105.251 14.5787 99.8331 14.5787Z"
          fill="white"
        />
        <path
          opacity="0.5"
          d="M121.375 57.7917C121.504 58.0497 123.052 57.4047 123.181 55.5988C123.31 53.0189 122.665 47.4722 123.052 45.4083C123.568 42.6994 124.729 39.2165 123.955 38.7006C123.31 40.3775 121.117 41.1515 120.086 41.1515C117.635 41.1515 115.7 43.0864 115.7 43.0864C115.7 43.0864 116.087 43.9893 116.861 46.4402C117.506 49.0201 120.859 56.6307 121.375 57.7917Z"
          fill="url(#paint0_linear)"
        />
        <path
          opacity="0.5"
          d="M139.048 62.9515C139.048 62.9515 138.016 61.6615 137.371 58.5657C136.726 55.3408 135.694 46.4402 135.694 46.4402C135.694 46.4402 136.468 47.6012 137.113 50.052C137.629 52.116 137.113 51.729 137.758 58.1787C137.887 59.2106 138.919 61.2745 139.048 62.9515Z"
          fill="url(#paint1_linear)"
        />
        <path
          opacity="0.5"
          d="M148.077 64.4994C148.077 64.4994 147.174 63.9834 146.658 62.4355C146.013 61.0165 145.239 56.8887 145.239 56.8887C145.239 56.8887 146.013 57.4047 146.529 58.5657C147.045 59.4686 146.529 59.3396 147.045 62.3065C147.045 62.8225 147.948 63.8544 148.077 64.4994Z"
          fill="url(#paint2_linear)"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="123.073"
            y1="41.4543"
            x2="117.136"
            y2="54.6289"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopOpacity="0" />
            <stop offset="1" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="139.918"
            y1="53.6567"
            x2="135.268"
            y2="55.4956"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopOpacity="0" />
            <stop offset="1" />
          </linearGradient>
          <linearGradient
            id="paint2_linear"
            x1="147.57"
            y1="60.3988"
            x2="145.812"
            y2="61.0939"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopOpacity="0" />
            <stop offset="1" />
          </linearGradient>
        </defs>
      </svg>
      <ButtonsHolder>
        <ArrowButton backward direction={direction}>
          <div className="arrow" />
          <span>{t("back")}</span>
        </ArrowButton>
        <ArrowButton next direction={direction}>
          <span>{t("next")}</span>
          <div className="arrow" />
        </ArrowButton>
      </ButtonsHolder>
    </KeysHelpHolder>
  );
}
